import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon, ChevronRightIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0D0118] pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-82">
      {/* Background Effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-83">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-[#FF2D8A]/20 blur-[120px]" data-id="element-84" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-[#9D00FF]/20 blur-[120px]" data-id="element-85" />
        <div className="absolute top-[20%] right-[10%] w-[20%] h-[20%] rounded-full bg-[#FFD700]/10 blur-[80px]" data-id="element-86" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-87">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left" data-id="element-88">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="inline-block mb-4 px-4 py-1.5 rounded-full border border-[#FF2D8A]/30 bg-[#FF2D8A]/10 backdrop-blur-sm" data-id="element-89">
            <span className="text-[#FF2D8A] font-semibold text-sm tracking-wider uppercase" data-id="element-90">
              El método definitivo
            </span>
          </motion.div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6" data-id="element-91">
            Expertas en <br data-id="element-92" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF2D8A] to-[#FFD700] font-black italic tracking-tight drop-shadow-[0_0_15px_rgba(255,45,138,0.5)]" data-id="element-93">
              BallCat
            </span>
          </h1>

          <p className="text-xl sm:text-2xl text-gray-300 mb-4 font-medium" data-id="element-94">
            69 técnicas para estimular el placer solo con la boca.
          </p>

          <p className="text-lg text-gray-400 mb-10 max-w-xl mx-auto lg:mx-0" data-id="element-95">
            31 posiciones increíbles para multiplicar el placer y convertirte en
            una maestra inolvidable.
          </p>

          <Button href="#pricing" className="w-full sm:w-auto text-xl px-10 py-5" data-id="element-96">
            ¡QUIERO ACCEDER AHORA!
            <ChevronRightIcon className="w-6 h-6 ml-2" data-id="element-97" />
          </Button>
        </motion.div>

        {/* Floating Product Mockup */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="relative flex items-center justify-center" data-id="element-98">
          <motion.div animate={{
          y: [0, -15, 0]
        }} transition={{
          repeat: Infinity,
          duration: 4,
          ease: 'easeInOut'
        }} className="relative" data-id="element-99">
            {/* Glow behind mockup */}
            <div className="absolute inset-0 bg-[#FF2D8A]/20 blur-[60px] rounded-full scale-75 pointer-events-none" data-id="element-100" />
            <div className="absolute inset-0 bg-[#9D00FF]/15 blur-[80px] rounded-full scale-90 pointer-events-none" data-id="element-101" />

            <img src="https://cdn.magicpatterns.com/uploads/iNNHjksEqgvbQMuLHPDuB9/freepik__romantic-intimate-atmosphere-couple-close-together__46398.png" alt="Expertas en BallCat - Producto Digital" className="relative z-10 w-full max-w-sm sm:max-w-md lg:max-w-lg rounded-2xl shadow-[0_0_50px_rgba(255,45,138,0.3)]" data-id="element-102" />
          </motion.div>
        </motion.div>
      </div>

      {/* Bottom Wave Divider */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-103">
        <svg className="relative block w-full h-[50px] sm:h-[100px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-104">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,119.93,193.63,108.58Z" fill="#1A0230" data-id="element-105"></path>
        </svg>
      </div>
    </section>;
}